export const visualizeAmount = (amount: number): string => {
    const main = Math.floor(amount / 100);
    const rest = Math.abs(amount % 100);
    return `${main}.${rest.toString().padStart(2, "0")}`;
}